
import React, { useState, useEffect } from 'react';

import { createContext, useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { withAuthenticator, Button, Heading, Flex } from '@aws-amplify/ui-react';
import { withSession, withSessionOr } from '../components/context/CurrentUserContext';

import UserInfo from './UserInfo'


import { SignInModel } from '../components/auth/LoginButton';

import { SignIn } from '../components/form/SignIn';
import { SignUp } from '../components/form/SignUp';

const modalStatusContext = createContext();

const Home = ({ user }) => {

  const [open, setOpen] = useState(false)

  const changeStatus = () => setOpen(!open)


  return (
    <div>

      <h3>Hello </h3>

      <modalStatusContext.Provider
        value={[open, setOpen]}
      >

        <Button backgroundColor={'pink'} onClick={changeStatus} >Login {open ? "T" : "F"}</Button>
        <Popup />

      </modalStatusContext.Provider>

    </div>
  );
};

const Popup = ({ user }) => {

  const [open, setOpen] = useContext(modalStatusContext);

  const changeStatus = () => setOpen(!open)


  return (


    <Flex
      direction="column"
      justifyContent="center"
      alignItems="center"
      //alignContent="flex-start"
      // wrap="nowrap"
      gap="1rem"
    >

      {/* <Button backgroundColor={'pink'} onClick={changeStatus} >X Login {open ? "T" : "F"}</Button> */}

      <SignUp border={false} /> 
      {/* {open ? : <></>} */}

    </Flex>


  );
};






export default withSessionOr(UserInfo, Home);

